import {configureChains, createConfig as createWagiConfig, mainnet} from '@wagmi/core';
import {publicProvider} from '@wagmi/core/providers/public';
import {metaMaskConnector} from './metamask';
import {chains} from '../shared';
import {walletConnectConnector} from './wallet-connect';

export function useConfig(): ReturnType<typeof createWagiConfig> {
  if (!process.browser) {
    return {} as any;
  }
  const {publicClient, webSocketPublicClient} = configureChains(chains, [publicProvider()]);

  return createWagiConfig({
    autoConnect: true,
    connectors: [metaMaskConnector, walletConnectConnector],
    publicClient,
    webSocketPublicClient,
  });
}
